<script lang="ts">
    import { defineCustomElement as advPopup } from '@didi/adv-ui/adv-retention-dialog';
    import { onMount } from 'svelte';

    import {
        END_CARD_RETENTION,
        END_CARD_RETENTION_CONFIRM,
        END_CARD_RETENTION_CONFIRM_COLOR,
        END_CARD_RETENTION_TEXT,
        END_CARD_RETENTION_TITLE,
        REGULAR_CARD_RETENTION
    } from '../constants/imgList';
    import { POPUP_ID } from '../enums';
    import { RETAIN_POPUP_CK } from '../enums/track';
    import { isJumpOneLink, omegaParams } from '../store/index';
    import { trackEvent } from '../utils/track';

    import { markPopBegin, markPopEnd } from '@/utils/fmpTrack';

    export let variant: 'regular' | 'end' = 'regular';
    export let bid = 'creditcard';
    export let isOnePage = 'true';

    $: fifaHeaderImg =
        variant === 'end' ? END_CARD_RETENTION : REGULAR_CARD_RETENTION;

    const handleShowPopup = (event: CustomEvent) => {
        if (event.detail) {
            markPopBegin({ popup_id: POPUP_ID.RETENTION_POPUP });
        }
    };

    const handleVisible = (event: CustomEvent) => {
        if (event.detail) {
            markPopEnd({ popup_id: POPUP_ID.RETENTION_POPUP });
        }
    };

    const handlePopupClose = (event: CustomEvent) => {
        if (event?.detail?.closeType === 'close') {
            trackEvent(RETAIN_POPUP_CK, {
                button_name: 'close',
                is_jump_success: 0
            });

            return;
        }

        if (event?.detail?.closeType === 'confirm') {
            trackEvent(RETAIN_POPUP_CK, {
                button_name: 'cta',
                is_jump_success: 0
            });
        }
    };

    onMount(() => {
        advPopup();
    });
</script>

<adv-retention-dialog
    {bid}
    is-fifa="true"
    fifa-header-img={fifaHeaderImg}
    credit-card-title={END_CARD_RETENTION_TITLE}
    credit-card-text={END_CARD_RETENTION_TEXT}
    confirm-text={END_CARD_RETENTION_CONFIRM}
    confirm-color={END_CARD_RETENTION_CONFIRM_COLOR}
    is-one-page={isOnePage}
    params={$omegaParams}
    is-jump-app="false"
    deepLinkState={$isJumpOneLink}
    on:popupClose={handlePopupClose}
    on:isVisible={handleVisible}
    on:showPopupState={handleShowPopup}
></adv-retention-dialog>
